/**
 * 優惠折扣活動類別之列舉
 *
 * @export
 * @enum {number}
 */
export enum DiscountType {
	/**
	 * 折趴數
	 */
	DISCOUNT_PERCENT = 'DISCOUNT_PERCENT',

	/**
	 * 折金額
	 */
	DISCOUNT_PRICE = 'DISCOUNT_PRICE',

}

